import Vue from "vue";
import Router from "vue-router";

import Views from "./views/"; // import all avaible views

import page404 from "@/views/404";

const PostTypes = window.WPVUE.post_types;
const WPVUE = window.WPVUE;
const defaultSingleComponent = Views["singlePage"];
const defaultArchiveComponent = Views["archivePosts"];

import { archivePageId } from "@/plugins/helpers";

// Clear unwanted router errors, related to multi level navi stuff
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(Router);
let wpRoutes = [];


let aktiviterTypeSettings = false
// console.log('Avaible Components:', Views)
// it is not Hierarchical YET!
for (var prop in PostTypes) {
  // skip loop if the property is from prototype
  if (!PostTypes.hasOwnProperty(prop)) continue;

  //const singlePT = PostTypes[prop];
  let name = `single${PostTypes[prop].name.capitalize()}`;
  let component = Views[name] ? Views[name] : defaultSingleComponent;

  //single Route
  if (PostTypes[prop].type === "page") continue;
  if (PostTypes[prop].type === "aktiviteter") {
    aktiviterTypeSettings = PostTypes[prop]
    continue
  }
  const singleRoute = {
    path:
      PostTypes[prop].type !== "page"
        ? `/${PostTypes[prop].rewrite}/:name`
        : "/:name",
    name,
    component,
    meta: {
      post_type: PostTypes[prop].type,
      type: "single",
      title: PostTypes[prop].labels.singular_name
    }
  };

  wpRoutes.push( singleRoute );


  //Archive routes
  if (PostTypes[prop].has_archive) {
    //replace because now it is type archive
    name = name.replace("single", "archive");
    component = Views[name] ? Views[name] : defaultArchiveComponent;
    const archiveRoute = {
      path: `/${PostTypes[prop].rewrite}`,
      name,
      component,
      query: { search: null, kategori: null },
      meta: {
        post_type: PostTypes[prop].type,
        type: "archive",
        title: PostTypes[prop].labels.all_items,
        id: archivePageId(PostTypes[prop].type)
      }
    };
    wpRoutes.push( archiveRoute );
  }
}

const aktiviterRoute = !aktiviterTypeSettings ? [] : [
  // {
  //   path: '/' + aktiviterTypeSettings.rewrite,
  //   name: "archiveAktiviteter",
  //   component: defaultArchiveComponent,
  //   meta: { post_type: "aktiviteter", type: "single", title: "Alle aktiviteter", id: archivePageId(aktiviterTypeSettings.type) },
  // },
  {
    path: '/' + aktiviterTypeSettings.rewrite + "/:name",
    name: "singleAktiviteter",
    component: Views["singlePage"],
    meta: { post_type: "aktiviteter", type: "single", title: "Aktiviteter" },
    children: [
      {
        path: ":name",
        component: Views["singlePage"],
        meta: { post_type: "aktiviteter", type: "single", title: "Aktiviteter" },
        children: [
          {
            path: ":name",
            meta: { post_type: "aktiviteter", type: "single", title: "Aktiviteter" },
            component: Views["singlePage"],
            children: [
              {
                path: ":name",
                meta: {
                  post_type: "aktiviteter",
                  type: "single",
                  title: "Aktiviteter"
                },
                component: Views["singlePage"]
              }
            ]
          }
        ]
      }
    ]
}]

const routes = [
  {
    path: "/",
    name: "frontPage",
    component: defaultSingleComponent,
    meta: {
      post_type: "page",
      type: "frontPage",
      title: "Hjem",
      id: window.WPVUE.front_page
    }
  },
  {
    path: "/404",
    name: "notFound",
    component: page404,
    meta: {
      post_type: null,
      type: "404",
      title: "Side ikke funnet"
    }
  },
  {
    path: "/" + WPVUE.search_page_slug,
    name: "search",
    component: Views["search"],
    query: { search: "", kategori: "" },
    meta: {
      post_type: "page",
      type: "search",
      title: "Search",
      id: window.WPVUE.options.archives.search_page
    }
  },
  ...wpRoutes,
  ...aktiviterRoute,
  //Media/Attachemnts
  {
    path: "/vedlegg/:name",
    name: "attachmentPage",
    component: Views["singleAttachment"],
    meta: { post_type: "attachment", type: "single", title: "Vedlegg" }
  },
  {
    path: "/vedlegg",
    redirect: { name: "frontPage" }
  },
  {
    path: "/:name",
    name: "singlePage",
    component: Views["singlePage"],
    meta: { post_type: "page", type: "single", title: "Single Page" },
    children: [
      {
        path: ":name",
        component: Views["singlePage"],
        meta: { post_type: "page", type: "single", title: "Single Page" },
        children: [
          {
            path: ":name",
            meta: { post_type: "page", type: "single", title: "Single Page" },
            component: Views["singlePage"],
            children: [
              {
                path: ":name",
                meta: {
                  post_type: "page",
                  type: "single",
                  title: "Single Page"
                },
                component: Views["singlePage"]
              }
            ]
          }
        ]
      }
    ]
  }
];

if (process.env.NODE_ENV === "development") {
  console.log("Router Generated", routes);
}



export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
